for(var i; i < 10; i++) {
  var cache_bust = 1;
}
